/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { Link, useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { OverlayTrigger, Tooltip } from "react-bootstrap"

/* Helpers, constants, custom methods, internal libraries */
import { TRAVELER_DETAILS_ROUTE, PEOPLE_TEAMS_ROUTE } from "../../../../constants/routes";
import { useUserService } from "../../../../services/userService";
import { dateFormatWithLocale } from '../../../../helpers/general';
import { useLocaleContext } from '../../../../contexts/localeContext';

/* Components */
import UCGrid from "../../../ucgrid/index.js";
import { ReactComponent as CCImage } from "../../../../resources/images/cc.svg";

/* Styles */
import styles from "./styles.js"

const RemovedPeopleGrid = (props) => {
  const { gridOptions, setGridOptions, peopleResponse } = props;
  const theme = useTheme();
  const classes = styles({ theme });
  const navigate = useNavigate();
  const { userDetails } = useUserService();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;
  const locale = useLocaleContext();

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <div className={classes.peopleGrid}>
      <UCGrid
        gridName="removedPeopleGrid"
        data={ peopleResponse?.results }
        columns={ peopleResponse?.columns }
        actions={ peopleResponse?.actions }
        handlePageChange={(page) => {setGridOptions({
          ...gridOptions,
          page
        })
        page > 1 ? navigate(`/app/people/removed?page=${page}`) : navigate(`/app/people/removed`)
        }}
        setSelectedRow={setSelectedRow}
        spinner="removedPeopleGridSpinner"
        customColumns={{
          roleName: (row) => (
            <p className={classes.role}>
              <Link to={TRAVELER_DETAILS_ROUTE.replace(":travelerId", row.entityID)} className={classes.link} state={{ userRowDetails: row }}>
                <FormattedMessage id={`roles.${row.roleId}.${providerCode}`} />
              </Link>
              {
                row.authorizedUser &&
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip" className={classes.tooltip}>
                      {
                        row.primaryContact ? 
                          <FormattedMessage id="peopleGrid.primarycitiicon"/> 
                        : <FormattedMessage id="peopleGrid.citiicon"/>
                      }
                    </Tooltip>
                  }
                >
                  <CCImage className={classes.cc}/>
                </OverlayTrigger>
              }
            </p>
          ),
          entityStatusChangedOn: (row) => (
           dateFormatWithLocale(row.entityStatusChangedOn, locale)
          ),
          parentName: (row) => (
            <Link to={`${"../../" + PEOPLE_TEAMS_ROUTE}/${row.parentID}`} className={classes.link}>
              {row.parentName}
            </Link>
          )
        }}
        defaultSort={peopleResponse?.defaultSort}
        handleSort={(column, sortDirection) =>
          setGridOptions({
            ...gridOptions,
            sortby: column.id,
            sortdirection: sortDirection === "desc" ? "dsc" : sortDirection,
          })
        }
        avatarNameLink={row => TRAVELER_DETAILS_ROUTE.replace(":travelerId", row.entityID)}
        onRowClickRoute={row => TRAVELER_DETAILS_ROUTE.replace(":travelerId", row.entityID)}
      />
    </div>
  )
}

export default RemovedPeopleGrid;
